module.exports = __webpack_public_path__ + "img/knight4_feature_02.8167fb7b.jpg";